import { render, staticRenderFns } from "./messageStandard.vue?vue&type=template&id=4cb39048&scoped=true&"
import script from "./messageStandard.vue?vue&type=script&lang=js&"
export * from "./messageStandard.vue?vue&type=script&lang=js&"
import style0 from "./messageStandard.vue?vue&type=style&index=0&id=4cb39048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb39048",
  null
  
)

export default component.exports